import { createApiClient, useMergeInterceptor } from '@inbody/data';
import { useApiErrorInterceptor } from '@inbody/error';
import { useAuthInterceptors } from '@inbody/keycloak';

const API_CLIENT = {
  baseUrl: import.meta.env.VITE_API_URL,
  clientId: 'indrive',
};

// type ClientType = keyof typeof API_CLIENTS;

export const useApiClient = () => {
  const { baseUrl, clientId } = API_CLIENT;
  const apiErrorInterceptor = useApiErrorInterceptor();

  if (clientId) {
    const authInterceptors = useAuthInterceptors({ clientId });

    const mergedInterceptors = useMergeInterceptor(
      apiErrorInterceptor,
      authInterceptors,
    );
    return createApiClient(baseUrl, {
      hooks: mergedInterceptors,
    });
  }

  return createApiClient(baseUrl, {
    hooks: apiErrorInterceptor,
  });
};
